import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { withNavItem } from './withNavItem';

class NavItemHeyo extends Component {
  constructor() {
    super();
    this.rendered = false;
  }
  componentDidMount() {
    this.rendered = true;
  }
  render() {
    this.props.isActiveLinkFunc(this.props.location.pathname === '/heyo/');
    return (
      <NavLink onClick={e => this.props.handleClick(e)} className={`nav-link nav-link--heyo ${this.props.imagesLoadedClass}`} activeClassName="nav-link--active" to="/heyo/">

        <span ref={el => this.props.navLinkFunc(el, this.rendered)} onMouseMove={e => this.props.mousemoveFn(e)} onMouseEnter={e => this.props.mouseenterFn(e)} onMouseLeave={e => this.props.mouseleaveFn(e)} className={`${this.props.wobbling} nav-link__inner`}>
          { /* If-Else in JSX https://react-cn.github.io/react/tips/if-else-in-JSX.html */
            /* this is an immediately invoked function */
            (() => {
              if (this.props.location.pathname === '/heyo/') {
                return (
                  <div className="self-portrait">
                    <div className="self-portrait__inner">
                      <img src="/img/dan-ohlsen.jpg" alt="" />
                      <span className="actual-size">actual size*</span>
                    </div>
                  </div>
                );
              }
            })()
          }
          <span className="nav-link__letter-holder letter-h">
            <span className="nav-link__letter">H</span>
            <span className="letter-strokes letter-strokes--h">
              <span className="h-left-stroke letter-stroke" style={{ transform: this.props.groupB }}>
                <svg className="letter-stroke__svg" viewBox="0 0 106 306">
                  <mask id="h-left-stroke-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M59,0c0,0,0.1,114-0.5,195.8S58,314.5,58,314.5" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#h-left-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/h-left-stroke@2x.jpg" width="106" height="306" />
                </svg>
              </span>
              <span className="h-middle-stroke letter-stroke" style={{ transform: this.props.groupD }}>
                <svg className="letter-stroke__svg" viewBox="0 0 118 106">
                  <mask id="h-middle-stroke-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M0.1,58c0,0,33.5-0.1,66.8,0.5s63.2,0.5,63.2,0.5" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#h-middle-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/h-middle-stroke@2x.jpg" width="118" height="106" />
                </svg>
              </span>
              <span className="h-right-stroke letter-stroke" style={{ transform: this.props.groupC }}>
                <svg className="letter-stroke__svg" viewBox="0 0 109 304">
                  <mask id="h-right-stroke-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M59,0c0,0,0.1,114-0.5,195.8S58,314.5,58,314.5" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#h-right-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/h-right-stroke@2x.jpg" width="109" height="304" />
                </svg>
              </span>
            </span>
          </span>

          <span className="nav-link__letter-holder letter-e">
            <span className="nav-link__letter">E</span>
            <span className="letter-strokes letter-strokes--e">
              <span className="e-left-stroke letter-stroke" style={{ transform: this.props.groupB }}>
                <svg className="letter-stroke__svg" viewBox="0 0 106 316">
                  <mask id="e-left-stroke-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M59,0c0,0,0.1,114-0.5,195.8S58,314.5,58,314.5" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#e-left-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/e-left-stroke@2x.jpg" width="106" height="316" />
                </svg>
              </span>
              <span className="e-top-stroke letter-stroke" style={{ transform: this.props.groupA }}>
                <svg className="letter-stroke__svg" viewBox="0 0 134 105">
                  <mask id="e-top-stroke-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M0.2,51c0,0,24.5-0.1,57.8,0.5s75.2,0.5,75.2,0.5" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#e-top-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/e-top-stroke@2x.jpg" width="134" height="105" />
                </svg>
              </span>
              <span className="e-middle-stroke letter-stroke" style={{ transform: this.props.groupC }}>
                <svg className="letter-stroke__svg" viewBox="0 0 127 103">
                  <mask id="e-middle-stroke-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M0.2,51c0,0,24.5-0.1,57.8,0.5s75.2,0.5,75.2,0.5" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#e-middle-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/e-middle-stroke@2x.jpg" width="127" height="103" />
                </svg>
              </span>
              <span className="e-bottom-stroke letter-stroke" style={{ transform: this.props.groupD }}>
                <svg className="letter-stroke__svg" viewBox="0 0 136 106">
                  <mask id="e-bottom-stroke-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M0.2,51c0,0,24.5-0.1,57.8,0.5s75.2,0.5,75.2,0.5" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#e-bottom-stroke-mask)" className="letter-stroke__svg-image" xlinkHref="/img/e-bottom-stroke@2x.jpg" width="136" height="106" />
                </svg>
              </span>
            </span>
          </span>

          <span className="nav-link__letter-holder letter-y">
            <span className="nav-link__letter">Y</span>
            <span className="letter-strokes letter-strokes--y">
              <span className="y-left-stroke letter-stroke" style={{ transform: this.props.groupD }}>
                <svg className="letter-stroke__svg" viewBox="0 0 196 232">
                  <mask id="y-left-stroke-mask-2">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M58,0c0,42,13.8,71.5,37,117c24,47,52,80,52,116" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#y-left-stroke-mask-2)" className="letter-stroke__svg-image" xlinkHref="/img/y-left-stroke@2x.jpg" width="196" height="232" />
                </svg>
              </span>
              <span className="y-right-stroke letter-stroke" style={{ transform: this.props.groupC }}>
                <svg className="letter-stroke__svg" viewBox="0 0 218 215">
                  <mask id="y-right-stroke-mask-2">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" style={{ strokeWidth: '219' }} d="M110.5,0.1c0,0,0.1,83.6-0.5,143.5c-0.5,60-0.5,90-0.5,90" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#y-right-stroke-mask-2)" className="letter-stroke__svg-image" xlinkHref="/img/y-right-stroke@2x.jpg" width="218" height="215" />
                </svg>
              </span>
              <span className="y-bottom-stroke letter-stroke" style={{ transform: this.props.groupA }}>
                <svg className="letter-stroke__svg" viewBox="0 0 106 122">
                  <mask id="y-bottom-stroke-mask-2">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M59,0.1c0,0,0.1,43.5-0.5,76.8S58,125.6,58,125.6" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#y-bottom-stroke-mask-2)" className="letter-stroke__svg-image" xlinkHref="/img/y-bottom-stroke@2x.jpg" width="106" height="122" />
                </svg>
              </span>
            </span>
          </span>

          <span className="nav-link__letter-holder letter-o">
            <span className="nav-link__letter">O</span>
            <span className="letter-strokes letter-strokes--o">
              <span className="o-stroke letter-stroke" style={{ transform: this.props.groupB }}>
                <svg className="letter-stroke__svg" viewBox="0 0 302 321">
                  <mask id="o-mask">
                    <path ref={el => this.props.activePaths(el, this.rendered)} className="letter-stroke__svg-path" d="M157,277c-54.7,0-99-49-99-109.5S102.3,58,157,58s99,49,99,109.5S211.7,277,157,277" />
                  </mask>
                  <image ref={image => this.props.svgImages(image, this.rendered)} mask="url(#o-mask)" className="letter-stroke__svg-image" xlinkHref="/img/o@2x.jpg" width="302" height="321" />
                </svg>
              </span>
            </span>
          </span>
        </span>
      </NavLink>

    );
  }
}

NavItemHeyo.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  activePaths: PropTypes.func.isRequired,
  svgImages: PropTypes.func.isRequired,
  imagesLoadedClass: PropTypes.string.isRequired,
  isActiveLinkFunc: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  navLinkFunc: PropTypes.func.isRequired,
  mousemoveFn: PropTypes.func.isRequired,
  mouseenterFn: PropTypes.func.isRequired,
  mouseleaveFn: PropTypes.func.isRequired,
  wobbling: PropTypes.string.isRequired,
  groupA: PropTypes.string.isRequired,
  groupB: PropTypes.string.isRequired,
  groupC: PropTypes.string.isRequired,
  groupD: PropTypes.string.isRequired,
};


export default withNavItem(NavItemHeyo);



// WEBPACK FOOTER //
// ./src/components/NavItemHeyo.js